import styled from "@emotion/styled"
import { PHeading, PTag } from "@porsche-design-system/components-react"
import { spacingFluidSm } from "@porsche-design-system/components-react/emotion"
import type { HeaderView, LocalizedLink } from "@slfinrtl/ui-bff-routes"
import type { JSX } from "react"
import { BackNavigation, CopyToClipboardInsideTag, StatusBadge, StickyHeader } from "src/components"
import { useMediaQueryWidth } from "src/hooks"
import { OpenListingButtonLink } from "../OpenListingButtonLink"

export interface HeaderStickyProps {
	actionMenu?: JSX.Element
	customerPrice: string | undefined | null
	inventoryNumber: string | undefined | null
	onOpenListingClick: (links: LocalizedLink[]) => Promise<void>
	view: HeaderView
}

export const HeaderSticky = ({
	actionMenu,
	customerPrice,
	inventoryNumber,
	onOpenListingClick,
	view,
}: HeaderStickyProps) => {
	const { badge, location, openListing, title, vin } = view

	const isSmall = useMediaQueryWidth({ min: "s" })
	const isMedium = useMediaQueryWidth({ min: "m" })

	return (
		<StickyHeader
			rightChild={
				<ButtonsWrapper>
					<OpenListingButtonLink onOpenListingClick={onOpenListingClick} openListing={openListing} />
					{actionMenu}
				</ButtonsWrapper>
			}
		>
			<BackNavigation hideLabel />
			<PHeading size="sm" ellipsis weight="bold">
				{title}
			</PHeading>
			<StatusBadge status={badge.status} autoWidth />
			{vin && (
				<PTag>
					<CopyToClipboardInsideTag value={vin} />
				</PTag>
			)}
			{isMedium && (
				<>
					{inventoryNumber && <PTag>{inventoryNumber}</PTag>}
					{customerPrice && <PTag>{customerPrice}</PTag>}
				</>
			)}
			{isSmall && location && <PTag>{location}</PTag>}
		</StickyHeader>
	)
}

const ButtonsWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, auto);
	gap: ${spacingFluidSm};
`
